<template>
  <div class="container">
      <div class="head">我的合同</div>
      <div v-for="(item,index) in contract" class="mycontract" >
                 <div>{{item.missionName}}</div>
                 <div>任务流水号：{{item.taskSerialCode}}</div>
                 <div>合同上传时间：{{item.uploadTime}}</div>
          <div>
                 <div></div>
                 <div>
                      <!-- <span @click="downloadTap(item)" >查看合同</span> -->
                      <span @click="downloadTap(item)" >下载合同</span>
                 </div>
         </div>
      </div>
      <!-- 引入分页器 -->
      <div class="PagePagination">
          <PagePagination ref="PageFrom" :pageIndex="pageIndex" :pageSize="pageSize" :total="total"></PagePagination>
      </div>
  </div>
</template>

<script>
  import PagePagination from "./pagePagination/pagePagination.vue"; //引入分页器
  import config from "../api/config";
  import manage from "../api/manage.js";
  export default {
    name: "myPrice",
    components: {
      PagePagination,
    },
    data() {
      return {
        pageIndex: 1,
        pageSize: 10,
        total:0,
        contract:[],  //合同数据
        baseUrl:config.baseUrl  //地址
      };
    },
    created() {
      this.getContract()
      console.log(this.pageIndex)
    },
    methods: {

      changePageIndex(page) {  //点击翻页
        console.log(page);
        this.pageIndex = page;
        setTimeout(() => {
          this.getContract();
        }, 100)
      },
      changePageInfo(current, size, total) {
        console.log(this.pageIndex,current)
        this.pageIndex = current;
        this.pageSize = size;
        this.total = total
      },
     async getContract(){  // 合同内容
         try {
            console.log(this.pageIndex,data)
           let data = {
             pageNo:this.pageIndex,
             pageSize:this.pageSize,
           }
           console.log(this.pageIndex,data)
           const res = await this.$http.getContract(data);
           if (res.code == 200) {
             this.changePageInfo(this.pageIndex,res.result.size,res.result.total)
              this.contract = res.result.records;
           } else {
             this.$message(res.message);
           }
         } catch (e) {

           throw e
         }
     },

      async downloadTap(item) { //下载pdf
        try {
          let data = {}
          let fileName = item.taskSerialCode+'.pdf';
          let baseUrl = this.baseUrl
          console.log(baseUrl)
          const res = await manage.downloadFile(`/api/common/static/${item.url}`,fileName,data)
        } catch (e) {
          this.$message(e.data ? e.data.message : e.message);
          throw e
        }
      },
},


  };
</script>

<style scoped="scoped" lang="less">
  .container{
     width: 900px;
     height: 544px;

     box-sizing: border-box;
    overflow: auto;
  }
  .container::-webkit-scrollbar {display:none}
  .head{
    width: 100%;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 22px;
    color: #3A3A3A;
    line-height: 64px;
    padding: 0 45px;
    border-bottom: 1px solid #c7c7c7;
  }
  .mycontract{
    margin: 16px 20px;
    border-bottom: 1px solid #D7D7D7;

  }
  .mycontract>div{
    margin-bottom: 8px;
    font-size:16px;
    color: #3a3a3a;
  }
  .mycontract>div:nth-of-type(1){
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .mycontract>div:nth-of-type(2){
    width: 100%;
    color: #D3D3D3;
  }
  .mycontract>div:nth-of-type(3){
    width: 100%;
    color: #D3D3D3;
  }
  .mycontract>div:nth-of-type(4){
    display: flex;
    justify-content: space-between;
  }
  .mycontract>div:nth-of-type(4)>div:nth-of-type(2)>span:nth-of-type(1){
   margin-right: 20rpx;
  }
  .mycontract>div:nth-of-type(4) span{
    color:#658fff;
  }
  .PagePagination{
    display: flex;
    justify-content: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/myContract.vue